import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from '../services/search.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  query: any;
  results: any;
  avatarBase: any;
  currentLang = 'en';

  constructor(
    private route: ActivatedRoute,
    private searchService: SearchService,
  ) {}

  ngOnInit(): void {
    this.avatarBase = environment.apiUrl + "/assets/";
    this.route.queryParams.subscribe((params) => {
      this.query = params["q"];
      // get results
      if (this.query) {
        this.searchService.getResults(this.query).subscribe((responseData) => {
          this.results = responseData;
          console.log(this.results);
        });
      }
    });
  }

  getResourceUrl(result: any) {
    let returnArray: any = [];
    switch (+result.content_section_id) {
      case 1:
        returnArray = ["/activity", "resources", result.content_page_id];
        break;
      case 2:
        returnArray = ["/activity", "steps", "resources", result.content_page_id];
        break;
      case 3:
        returnArray = ["/activity", "fit", "resources", result.content_page_id];
        break;
      case 4:
        returnArray = ["/activity", "move", "resources", result.content_page_id];
        break;
      case 5:
        returnArray = ["/activity", "breathe", "resources", result.content_page_id];
        break;

      
      case 7:
        returnArray = ["/modules", "i-quit", "resources", result.content_page_id];
        break;
      
      case 8:
        returnArray =["/modules", "eat-well", "resources", result.content_page_id];
        break;
      
      case 9:
        returnArray = ["/modules", "sleep-well", "resources", result.content_page_id];
        break;
      
      case 10:
        returnArray =["/modules", "feel-well", "resources", result.content_page_id];
        break;

      case 11:
        returnArray = ["/modules", "drink-guide", "resources", result.content_page_id];
        break;
    }
    return returnArray;
  }
}
